/**
 * @generated SignedSource<<64ebe5791e69d1ccc4551ea758d3881f>>
 * @relayHash c6b3f7b602e21301bb20e295cd56fbfa
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 444835ea3fd0742a08b38e0e8a4d4c8bdb9b262282631dab11e91ceda874be46

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { src_jiraBoardQuery } from './src_jiraBoardQuery.graphql';

const node: PreloadableConcreteRequest<src_jiraBoardQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "444835ea3fd0742a08b38e0e8a4d4c8bdb9b262282631dab11e91ceda874be46",
    "metadata": {},
    "name": "src_jiraBoardQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
